import Hero from './components/Hero';
import BulletCards from './components/BulletCards';
import Story from './components/Story';
import CTASection from '@/components/feature/CTASection';

const limits = [
  {
    icon: 'ri-time-line',
    title: '経営者の時間の限界',
    bullets: [
      '重要な判断に使う時間がない。',
      '目の前の業務に追われている。',
      '確認や承認に時間がかかる。',
      '経営者にしかできない仕事に集中できない。',
    ],
  },
  {
    icon: 'ri-error-warning-line',
    title: '判断の限界',
    bullets: [
      '必要な情報がまとまっていない。',
      '判断に必要な数字がすぐに見えない。',
      '問題が起きてから対応している。',
      '判断が経験や勘に依存している。',
    ],
  },
  {
    icon: 'ri-team-line',
    title: '組織の限界',
    bullets: [
      '業務が特定の人に集中している。',
      '担当者が変わると仕事が止まる。',
      '同じ業務を何度も繰り返している。',
      '現場が判断できず、確認が集中している。',
    ],
  },
];

const approach = [
  {
    icon: 'ri-links-line',
    title: '情報をつなぐ',
    bullets: [
      '会社の中に分散している情報をまとめる。',
      '必要な情報を見つけやすくする。',
      '判断に必要な情報を確認しやすくする。',
      '情報を探す時間を減らす。',
    ],
  },
  {
    icon: 'ri-search-eye-line',
    title: '業務を見直す',
    bullets: [
      '日々の業務を洗い出す。',
      '重複している業務を見つける。',
      '繰り返し発生する業務を減らす。',
      '業務の流れを把握しやすくする。',
    ],
  },
  {
    icon: 'ri-flow-chart',
    title: '判断の流れを整える',
    bullets: [
      '誰が判断するのかを明確にする。',
      'どの情報で判断するのかを明確にする。',
      '確認や承認が必要な箇所を分ける。',
      '判断が止まる箇所を見つける。',
    ],
  },
  {
    icon: 'ri-book-2-line',
    title: '知識を残す',
    bullets: [
      '一部の人だけが持つ知識を共有する。',
      '業務の進め方を残す。',
      '担当者が変わっても対応しやすくする。',
      '組織の中に知識を蓄積する。',
    ],
  },
];

const empower = [
  {
    icon: 'ri-compass-3-line',
    title: '経営者の判断',
    bullets: [
      '判断に必要な情報を確認しやすくする。',
      '判断の基準を明確にする。',
      '経営者が行うべき判断に集中できる状態をつくる。',
    ],
  },
  {
    icon: 'ri-play-circle-line',
    title: '現場の実行',
    bullets: [
      '現場が必要な情報を確認できる。',
      '業務の進め方を確認できる。',
      '判断を待つ時間を減らす。',
    ],
  },
  {
    icon: 'ri-database-2-line',
    title: '組織の蓄積',
    bullets: [
      '業務の知識を組織に残す。',
      '経験やノウハウを共有する。',
      '人が変わっても業務を続けやすくする。',
    ],
  },
];

export default function Home() {
  return (
    <>
      <Hero />

      <BulletCards
        eyebrow="Limits"
        title="会社の成長を止める、3つの限界。"
        cards={limits}
        columns={3}
      />

      <Story
        eyebrow="Why"
        title="頑張っているのに、成長が止まる理由。"
        paragraphs={[
          '売上を伸ばす。人を採用する。新しい施策を始める。業務を増やす。それでも、会社の成長が速くならないことがあります。経営者の判断が集中している。情報が必要な人に届いていない。業務の流れが見えにくくなっている。問題の発見が遅れている。小さな滞りが積み重なり、会社全体の動きを遅くしています。',
        ]}
        className="bg-[#12121f]"
      />

      <BulletCards
        eyebrow="Approach"
        title="AIを活用して、会社の中にある滞りを見つける。"
        cards={approach}
        columns={4}
      />

      <Story
        eyebrow="Purpose"
        title="AIの導入が目的ではない。"
        paragraphs={[
          'AIを導入することだけでは、会社は変わりません。大切なのは、会社の業務にAIを組み込むことです。経営者の判断を速くする。現場の確認を減らす。情報を探す時間を減らす。同じ業務を繰り返す時間を減らす。現場が判断しやすい状態をつくる。LUVIRAは、AIの活用を会社の成長につなげます。',
        ]}
        className="bg-[#12121f]"
      />

      <BulletCards
        eyebrow="Empower"
        title="経営者だけに集中していたものを、組織の力に変える。"
        cards={empower}
        columns={3}
      />

      <Story
        eyebrow="Time"
        title="経営者の時間を、次の成長に使う。"
        paragraphs={[
          '目の前の確認に追われない。同じ説明を繰り返さない。情報を探し続けない。すべての判断を一人で抱えない。現場が動くまで待ち続けない。経営者が、本来向き合うべき成長の判断に時間を使える状態を目指します。',
        ]}
        className="bg-[#12121f]"
      />

      <CTASection
        title="会社を成長させる力は、すでに社内にある。"
        description="経営者の経験がある。現場の知識がある。顧客との関係がある。積み重ねてきた業務がある。必要なのは、それらをつなぎ、動かす仕組みです。"
        buttonText="成長を止めている課題を相談する"
        closing="経営者の限界を、会社の限界にしない。LUVIRAはAIを活用し、会社の成長を支える仕組みづくりを支援します。"
      />
    </>
  );
}